var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMapSite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_339_3424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3401 0.659768C16.7901 0.109768 16.0001 -0.120232 15.2401 0.0597681L3.24008 2.58977C1.19008 2.86977 -0.249923 4.75977 0.0400771 6.80977C0.150077 7.61977 0.520077 8.36977 1.10008 8.94977L2.39008 10.2398C2.53008 10.3798 2.61008 10.5698 2.61008 10.7698V13.1498C2.61008 13.4798 2.69008 13.8098 2.84008 14.1098L2.86008 14.1298C3.08008 14.5698 3.44008 14.9298 3.88008 15.1498L3.90008 15.1698C4.20008 15.3098 4.53008 15.3898 4.86008 15.3898H7.24008C7.44008 15.3898 7.63008 15.4698 7.77008 15.6098L9.06008 16.8998C9.76008 17.6098 10.7101 17.9998 11.7001 17.9998C12.1101 17.9998 12.5201 17.9298 12.9001 17.7998C14.2401 17.3598 15.2101 16.1998 15.4101 14.8098L17.9401 2.77977C18.1301 2.01977 17.9001 1.20977 17.3501 0.659768H17.3401ZM3.45008 9.17977L2.16008 7.88977C1.55008 7.28977 1.34008 6.38977 1.62008 5.57977C1.89008 4.74977 2.63008 4.15977 3.50008 4.05977L15.3701 1.55977L4.10008 12.8298V10.7598C4.10008 10.1598 3.87008 9.58977 3.44008 9.16977L3.45008 9.17977ZM13.9301 14.5598C13.7601 15.7898 12.6201 16.6498 11.3901 16.4798C10.9101 16.4098 10.4601 16.1898 10.1101 15.8498L8.82008 14.5598C8.40008 14.1398 7.83008 13.8998 7.23008 13.8998H5.16008L16.4401 2.61977L13.9301 14.5498V14.5598Z",
    fill: "#767676"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_339_3424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMapSite);
export default __webpack_public_path__ + "static/media/ico-map-site.847b3c652bddc6a26d18073c0fa9dbce.svg";
export { ForwardRef as ReactComponent };